import { queryKeys } from '@/hooks/constants';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import AppService from '@/lib/App';

export function useGetTechFamilies(
  search?: string,
  options?: { [key: string]: any },
) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.techFamilies(search),
    queryFn: () => AppService.planner.getTechFamilies(search),
    ...options,
  });
}
